/* istanbul ignore file */
/* tslint:disable */
/* Polyfill must return "NULL" if HTMLElement is not found */
export function Closest() {
    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype["msMatchesSelector"] || Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            // needs to be any to avoid typing issues
            var el = this;
            if (document.documentElement && !document.documentElement.contains(el)) {
                return null;
            }
            do {
                if (el.matches(s)) {
                    return el;
                }
                el = el.parentElement;
            } while (el !== null);
            return null;
        };
    }
}
//# sourceMappingURL=Closest.js.map